export const primaryColor = "#53C3EB";
export const secondaryColor = "#A0ACB9";

export const formatNumber = (value) => {
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `${(value / 1_000).toFixed(1)}k`;
  return value;
};

export const HOURS = Array.from({ length: 24 }, (_, h) =>
  h === 0 ? "12 AM" : h < 12 ? `${h} AM` : h === 12 ? "12 PM" : `${h - 12} PM`,
);

export const DAYS = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

export const getHeatColor = (value) => {
  if (value == null || value <= 0) return "#EB5A5A";

  if (value <= 20) return "#EB5A5A";
  if (value <= 50) return "#EE740D";
  if (value <= 70) return "#63D376";
  return "#19AE32";
};

export const tooltipCursorStyle = { fill: "rgba(0,0,0,0.02)" };

export const tooltipContentStyle = {
  background: "#fff",
  borderRadius: "8px",
  border: "1px solid #E6EAF0",
  fontSize: "12px",
};

export const getTotalValue = (data = []) => {
  return data.reduce((sum, item) => sum + (Number(item.value) || 0), 0);
};

export const emptyDonut = [
  {
    label: "No Data",
    value: 1, // must be > 0
    color: "#E6EAF0",
  },
];

// dashboard.config.js
export const DASHBOARD_TABS = {
  OVERVIEW: {
    id: 1,
    key: "overview",
    label: "Overview",
    component: "Overview",
    subTypes: ["stats", "charts", "storeStatus"],
  },
  OPERATIONS: {
    id: 2,
    key: "operations",
    label: "Operations",
    component: "Operations",
    subTypes: ["stats", "charts", "storeStatus"],
  },
  CUSTOMERS: {
    id: 3,
    key: "customers",
    label: "Customers",
    component: "Customers",
    subTypes: ["stats", "charts", "donutChart"],
    extraApi: "recentActivity",
  },
  FINANCIAL: {
    id: 4,
    key: "financial",
    label: "Financial",
    component: "Financial",
    subTypes: ["stats", "charts", "donutChart"],
    extraApi: "recentActivity",
  },
};

export const TAB_LIST = Object.values(DASHBOARD_TABS);
